const BASE_URLS = {
  development: 'http://localhost:8000',
  production: 'https://backend.marinersmentor.com'
};

export const API_BASE_URL = BASE_URLS.production;